module.exports = __webpack_public_path__ + "static/img/268_TO8_2361_og.7739e4a.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/268_TO8_2361_og.jpg
// module id = 4tFk
// module chunks = 0